import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useEffect, useState } from 'react';
import { collection, getDocs, getFirestore, onSnapshot, orderBy, query, Timestamp, where } from "firebase/firestore";
import CustomTooltip from './components';
import dayjs, { Dayjs } from 'dayjs';


export default function EarningsOverTime(props){

    const [requests, setRequests] = useState("0");
    const db = getFirestore();


    const [requestsData, setRequestsData] = useState(
        [
            { name: '0', uv: 0, pv: 2400, amt: 2400 },
           
        ]
    );


    useEffect(async () => {
        var totalEarnings = 0;

        const oneTime = query(collection(db, "requests"),where("status","==","complete"));

        var docs = await getDocs(oneTime);
        docs.forEach((doc) => {
            totalEarnings +=doc.data()["amount"]*0.3 ;
        })
        setRequests(totalEarnings);
    }, [])



    return (
        <div className='bg-white/10 flex flex-row'>
            <AreaChart
                className='flex-1'
                width={700}
                height={400}
                data={requestsData}
                margin={{
                    top: 10,
                    right: 30,
                    left: 0,
                    bottom: 0,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip content={<CustomTooltip/>} />
                <Area type="monotone" dataKey="uv" stroke="white" fill="orange" />
            </AreaChart>

            <div className='flex-1 bg-white/10 flex flex-col justify-between items-start p-5'>
                <div className='text-3xl flex-col'>
                    <div>
                        Earnings Over Time
                    </div>
                    <div className='text-6xl font-bold mt-4'>
                        {requests}₵
                    </div>
                </div>
                
                <div className='flex flex-row gap-3'>
                    <button
                        onClick={async () => {

                            var current = dayjs();
                            var last = current.subtract(7, "day");

                            var dateRanges = new Map();

                            for (let index = 0; index < 8; index++) {
                                var loopDate=current.subtract(index,"day").toDate();
                                var day=loopDate.getDate();
                                var month=loopDate.getMonth()+1;
                                var year=loopDate.getFullYear();
                                var mapDate=`${day}-${month}-${year}`.toString();
                                console.log(mapDate);
                                dateRanges.set(mapDate.toString(), 0);
                            }


                            const q = query(collection(db, "requests"), where("createdAt", ">", Timestamp.fromDate(last.toDate())),where("status","==","complete"));
                            const querySnapshot = await getDocs(q);
                            querySnapshot.forEach((doc) => {
                                var loopDate=doc.data()["createdAt"].toDate();
                                var day=loopDate.getDate();
                                var month=loopDate.getMonth()+1;
                                var year=loopDate.getFullYear();
                                var mapDate=`${day}-${month}-${year}`.toString();

                                var val = dateRanges.get(mapDate.toString());
                                dateRanges.set(mapDate.toString(), val + doc.data()["amount"]*0.3);
                            });
                            console.log("queried");
                            console.log(dateRanges);

                            var tempData=[];
                            var totalrequests=0
                            dateRanges.forEach((value,key)=>{
                                tempData.unshift(
                                    { name: key.toString(), uv: value, pv: 2400, amt: 2400 },
                                );
                                totalrequests+=value;
                            })
                            setRequestsData([...tempData]);
                            setRequests(totalrequests);

                        }}
                        className='p-2 bg-white text-black font-bold rounded'>1W</button>
                    <button 
                    onClick={async () => {

                        var current = dayjs();
                        var last = current.subtract(1, "month");

                        var dateRanges = new Map();

                        for (let index = 0; index < 30; index++) {
                            var loopDate=current.subtract(index,"day").toDate();
                            var day=loopDate.getDate();
                            var month=loopDate.getMonth()+1;
                            var year=loopDate.getFullYear();
                            var mapDate=`${day}-${month}-${year}`.toString();
                            console.log(mapDate);
                            dateRanges.set(mapDate.toString(), 0);
                        }


                        const q = query(collection(db, "requests"), where("createdAt", ">", Timestamp.fromDate(last.toDate())),where("status","==","complete"));
                        const querySnapshot = await getDocs(q);
                        querySnapshot.forEach((doc) => {
                            var loopDate=doc.data()["createdAt"].toDate();
                            var day=loopDate.getDate();
                            var month=loopDate.getMonth()+1;
                            var year=loopDate.getFullYear();
                            var mapDate=`${day}-${month}-${year}`.toString();

                            var val = dateRanges.get(mapDate.toString());
                            dateRanges.set(mapDate.toString(), val + doc.data()["amount"]*0.3);
                        });
                        console.log("queried");
                        console.log(dateRanges);

                        var tempData=[];
                        var totalrequests=0
                        dateRanges.forEach((value,key)=>{
                            tempData.unshift(
                                { name: key.toString(), uv: value, pv: 2400, amt: 2400 },
                            );
                            totalrequests+=value;
                        })
                        setRequestsData([...tempData]);
                        setRequests(totalrequests);

                    }}
                    className='p-2 bg-white text-black font-bold rounded'>1M</button>
                    <button
                    onClick={async () => {

                        var current = dayjs();
                        var last = current.subtract(1, "year");

                        var dateRanges = new Map();

                        for (let index = 0; index < 365; index++) {
                            var loopDate=current.subtract(index,"day").toDate();
                            var day=loopDate.getDate();
                            var month=loopDate.getMonth()+1;
                            var year=loopDate.getFullYear();
                            var mapDate=`${day}-${month}-${year}`.toString();
                            console.log(mapDate);

                            dateRanges.set(mapDate.toString(), 0);
                        }


                        const q = query(collection(db, "requests"), where("createdAt", ">", Timestamp.fromDate(last.toDate())),where("status","==","complete"));
                        const querySnapshot = await getDocs(q);
                        querySnapshot.forEach((doc) => {
                            var loopDate=doc.data()["createdAt"].toDate();
                            var day=loopDate.getDate();
                            var month=loopDate.getMonth()+1;
                            var year=loopDate.getFullYear();
                            var mapDate=`${day}-${month}-${year}`.toString();

                            var val = dateRanges.get(mapDate.toString());
                            dateRanges.set(mapDate.toString(), val + doc.data()["amount"]*0.3);
                        });
                        console.log("queried");
                        console.log(dateRanges);

                        var tempData=[];
                        var totalrequests=0
                        dateRanges.forEach((value,key)=>{
                            tempData.unshift(
                                { name: key.toString(), uv: value, pv: 2400, amt: 2400 },
                            );
                            totalrequests+=value;
                        })
                        setRequestsData([...tempData]);
                        setRequests(totalrequests);

                    }}
                    className='p-2 bg-white text-black font-bold rounded'>1Y</button>
                    <button
                    onClick={async () => {

                        var current = dayjs();
                        var last = current.subtract(1, "year");

                        var dateRanges = new Map();

                        for (let index = 0; index < 365; index++) {
                            var loopDate=current.subtract(index,"day").toDate();
                            var day=loopDate.getDate();
                            var month=loopDate.getMonth()+1;
                            var year=loopDate.getFullYear();
                            var mapDate=`${day}-${month}-${year}`.toString();
                            console.log(mapDate);
                            dateRanges.set(mapDate.toString(), 0);
                        }


                        const q = query(collection(db, "requests"), where("createdAt", ">", Timestamp.fromDate(last.toDate())),where("status","==","complete"));
                        const querySnapshot = await getDocs(q);
                        querySnapshot.forEach((doc) => {
                            var loopDate=doc.data()["createdAt"].toDate();
                            var day=loopDate.getDate();
                            var month=loopDate.getMonth()+1;
                            var year=loopDate.getFullYear();
                            var mapDate=`${day}-${month}-${year}`.toString();

                            var val = dateRanges.get(mapDate.toString());
                            dateRanges.set(mapDate.toString(), val + doc.data()["amount"]*0.3);
                        });
                        console.log("queried");
                        console.log(dateRanges);

                        var tempData=[];
                        var totalrequests=0
                        dateRanges.forEach((value,key)=>{
                            tempData.unshift(
                                { name: key.toString(), uv: value, pv: 2400, amt: 2400 },
                            );
                            totalrequests+=value;
                        })
                        setRequestsData([...tempData]);
                        setRequests(totalrequests);

                    }}
                    className='p-2 bg-white text-black font-bold rounded'>All</button>
                </div>
            </div>

        </div>
    )

}